import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import { GlobalService } from './../core/global.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../core/global.service";
var AuctionService = /** @class */ (function () {
    function AuctionService(_http, _global) {
        this._http = _http;
        this._global = _global;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'eqcpcc': this._global.find(_GlobalNS.paths.eqcpcc)
            })
        };
    }
    AuctionService.prototype.getAuctionData = function (parameters, paginationParams) {
        var _this = this;
        var api = _GlobalNS.api.auction.data;
        var params = new HttpParams().set('LoanNumber', parameters.loan)
            .set('ReservePriceMin', parameters.minReservePrice)
            .set('ReservePriceMax', parameters.maxReservePrice)
            .set('ReservePrice', parameters.exactReservePrice)
            .set('RecordOffset', paginationParams.offset.toString())
            .set('PageRecords', paginationParams.pageSize.toString())
            .set('SortDir', paginationParams.sortDir.toString())
            .set('SortValue', paginationParams.sortValue.toString())
            .delete('LoanNumber', '')
            .delete('ReservePriceMin', '')
            .delete('ReservePriceMax', '')
            .delete('ReservePrice', '');
        this.httpOptions['params'] = params;
        return this._http.get("" + api, this.httpOptions)
            .pipe(map(function (response) { return _this.formatData(response); }), catchError(function (error) { return throwError(error); }));
    };
    AuctionService.prototype.formatData = function (response) {
        var formattedData = response;
        formattedData.data = this.getData(response);
        return formattedData;
    };
    AuctionService.prototype.getData = function (response) {
        var _this = this;
        var loanItems = [];
        response.data.map(function (loanObject) {
            var tempData = _this.setRowData(loanObject);
            loanItems.push(tempData);
        });
        return loanItems;
    };
    AuctionService.prototype.setRowData = function (element) {
        if (!element.LoanDataAvailable) {
            return {
                propertyId: element.PropertyId,
                loan: element.LoanNumber,
                loanDataAvailable: element.LoanDataAvailable
            };
        }
        else {
            return {
                propertyId: element.PropertyId,
                loan: element.LoanNumber,
                loanDataAvailable: element.LoanDataAvailable,
                auctionCycle: element.LatestListingDetails.listingRound,
                auctionEndingIn: element.AuctionTimeLeft,
                highestBid: element.LatestListingDetails.highestBidAmount,
                totalBids: element.LatestListingDetails.totalBids,
                reservePrice: element.LatestListingDetails.reservePrice,
                edit: false,
                reserveMet: element.ReservePricePercentageMet,
                listStartDate: element.LatestListingDetails.listingStartDate,
                listEndDate: element.LatestListingDetails.listingEndDate,
                bidders: element.LatestListingDetails.numberOfBidders,
                views: element.LatestListingDetails.numberOfViews,
                saves: element.NumberOfSaves,
                initialReservePrice: element.InitialReservePrice,
                perInitialReservePrice: element.InitialReservePrice != (null || 0) ? (element.LatestListingDetails.reservePrice / element.InitialReservePrice) * 100 : null,
                perInitialReservePriceOld: element.InitialReservePrice != (null || 0) ? (element.LatestListingDetails.reservePrice / element.InitialReservePrice) * 100 : null,
                reservePriceReduction: (element.UpdateStatusValue == 'Request Complete' ||
                    (element.UpdateStatusValue == null || element.UpdateStatusValue == '')) ? null : element.ReservePriceReductionPercentageNew,
                reservePriceReductionOld: element.ReservePriceReductionPercentageNew,
                newReservePrice: (element.UpdateStatusValue == 'Request Complete' ||
                    (element.UpdateStatusValue == null || element.UpdateStatusValue == '')) ? null : (element.ReservePriceNew == ("null" || null) ? '' : element.ReservePriceNew),
                reservePriceOld: element.ReservePriceOld,
                startbid: element.LatestListingDetails.startingBidAmount,
                requestStatus: element.UpdateStatusValue,
                originalReservePrice: element.LatestListingDetails.reservePrice,
                originalperInitialReservePrice: element.InitialReservePrice != (null || 0) ? (element.LatestListingDetails.reservePrice / element.InitialReservePrice) * 100 : null,
                originalnewReservePrice: element.ReservePriceNew,
                refreshState: false,
                reservePriceChangedBy: element.UpdateOperatorName,
                reservePriceChangedDate: element.UpdateDate == ("null" || null) ? '' : element.UpdateDate,
                canEditReservePrice: element.CanEditReservePrice == (null || false || 0) ? false : true,
                counter: 10,
                counter$: null,
                errorMessage: ''
            };
        }
    };
    AuctionService.prototype.updateReservePriceAuctionData = function (postparms) {
        var api = _GlobalNS.api.auction.updateReservePrice;
        var eqrf = this._global.find(_GlobalNS.paths.eqrf);
        return this._http.post(api + "&eqrf=" + eqrf, postparms)
            .pipe(map(function (response) { return response; }), catchError(function (error) { return throwError(error); }));
    };
    AuctionService.ngInjectableDef = i0.defineInjectable({ factory: function AuctionService_Factory() { return new AuctionService(i0.inject(i1.HttpClient), i0.inject(i2.GlobalService)); }, token: AuctionService, providedIn: "root" });
    return AuctionService;
}());
export { AuctionService };
